/** Sentinel meal choice when a guest does not want a course option from the ticket menu. */
export const MEAL_CHOICE_NONE = 'None';

/** Ticket/event course options plus {@link MEAL_CHOICE_NONE} when not already configured. */
export function getCourseSelectOptions(options: string[] | undefined): string[] {
  const base = (options ?? []).filter((option) => typeof option === 'string' && option.trim() !== '');
  if (base.some((option) => option.trim().toLowerCase() === MEAL_CHOICE_NONE.toLowerCase())) {
    return base;
  }
  return [...base, MEAL_CHOICE_NONE];
}

/** True when the organiser picked a course (including None); false for blank placeholder. */
export function isMealCourseSelectionComplete(value: string | undefined): boolean {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  return trimmed.length > 0;
}
